import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private ipApiUrl = 'https://ipapi.co/json/';
  private userCountryCode: string | null = null;

  constructor(private http: HttpClient, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    // If the country code is already fetched, use the cached value.
    if (this.userCountryCode) {
      if (this.userCountryCode === 'IN') {
        // If in India and trying to access the root, redirect to analytics.
        if (state.url === '/') {
          return this.router.createUrlTree(['/in']);
        }
        return true;
      } else {
        // Not in India, allow access to root, but redirect from analytics.
        // if (state.url === '/in') {
        //   return this.router.createUrlTree(['/home']);
        // }
        return this.router.createUrlTree(['/home']);;
      }
    }

    // Fetch the country code if it hasn't been fetched yet.
    return this.http.get<{ country_code: string }>(this.ipApiUrl).pipe(
      map(response => response.country_code),
      tap(countryCode => this.userCountryCode = countryCode), // Cache the result
      map(countryCode => {
        if (countryCode === 'IN') {
          // User is in India.
          if (state.url === '/') {
            // Redirect to analytics if they try to go to the root.
            return this.router.createUrlTree(['/in']);
          }
          // Otherwise, allow navigation.
          return true;
        } else {
          // User is not in India.
          if (state.url === '/in') {
            // Redirect to root if they try to access analytics.
            return this.router.createUrlTree(['/']);
          }
          // Otherwise, allow navigation.
          return true;
        }
      }),
      catchError(error => {
        console.error('Error fetching IP data:', error);
        // On error, default to allowing navigation to the root route.
        if (state.url === '/in') {
          return of(this.router.createUrlTree(['/']));
        }
        return of(true);
      })
    );
  }
}